<template>
  <!-- 应收单管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            trackCode="receivablesReceiveList-1"
            @search="handleSearch"
            @reset="handleReset"
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #sourceList>
              <page-source-select
                title="归属业务"
                :sources="sourceList"
                @select-change="sourceChange"
              />
            </template>
          </page-select-groups>
          <!-- 导出报表按钮 -->
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <template v-if="$has('FWS-SFKGL-YSD-DC')">
              <page-export-button
                title="应收单报表导出"
                exportServe="fin_receipt_receiveReport"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode="receivablesReceiveList-3"
              />
            </template>
          </div>
        </div>
      </template>

      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="receiveListRef"
        >
          <template v-slot:recApplyNo="{row}">
            <jr-tooltip
              :content="row.recApplyNo"
              type="popover"
              :isFilter="true"
            />
          </template>
          <template v-slot:waitDivideAmount="{row}">
            <div v-if="row.waitDivideAmount === null">无需分账</div>
            <div v-else>{{row.waitDivideAmount | toFenThousandsAndFloat}}</div>
          </template>
        </jr-table>
      </template>

      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :receive-no.sync="receiveNo"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode="receivablesReceiveList-2"
    />
    <!-- 添加收款 -->
    <receipt-dialog
      :visible.sync="isAddReceipt"
      :receipt-data="currentRow"
      @success="getList"
    />
  </div>
</template>

<script>
import { getReceiveList } from '@/api/receivables/receive';
import detail from '../components/receive-detail';
import { setStatusColor } from '@/filters/index';
import receiptDialog from './components/receipt-dialog';
import { getMonthDate } from '@/utils/date';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchKey: '', // 搜索值
  searchType: 'orderNumber',
  receiveStatus: '', // 核销状态
  paymentStatus: '', // 收款状态
  orderNumber: '', // 业务订单编号
  receiveNo: '', // 应收单编号
  type: '', // 应收单类型
  transType: 2, // 订单交易类型1=自营2=服务商
  timeType: '1',
};

const optionsList = [
  {
    value: 'orderNumber',
    label: '业务订单编号',
  }, {
    value: 'receiveNo',
    label: '应收单编号',
  }, {
    value: 'recBusinessNo',
    label: '客户编号',
  }, {
    value: 'recApplyNo',
    label: '申请单号',
  },
];

export default {
  name: 'ReceivablesReceiveList',
  components: { detail, receiptDialog },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      isDetailShow: false, // 详情弹窗
      isBatchSearchShow: false, // 批量搜索
      receiveNo: '', // 应收单编号
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchKey',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            ...optionsList,
            {
              value: 'recBusinessName',
              label: '客户名称',
            },
            {
              value: 'payeeBusinessName',
              label: '服务商名称',
            },
          ],
        },
      ],
      // 批量搜索条件集合
      batchSearchTypeList: [...optionsList],
      tableColumn: [
        {
          prop: 'receiveNo',
          label: '应收单编号',
          minWidth: '1',
          permission: 'FWS-SFKGL-YSD-XQ',
          disabled: true,
          trackCode: 'receivablesReceiveList-5',
          click: (row) => {
            this.handleDetail(row);
          },
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'recApplyNo', label: '申请单号', minWidth: '1', slotName: 'recApplyNo' },
        { prop: 'payeeBusinessName', label: '服务商名称', minWidth: '1' },
        { prop: 'typeDesc', label: '应收类型', minWidth: '1' },
        { prop: 'recBusinessName', label: '客户名称', minWidth: '1' },
        { prop: 'recBusinessNo', label: '客户编号', minWidth: '1' },
        { prop: 'shouldRecAmount', label: '应收金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'realAmount', label: '实收金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'alreadyRecAmount', label: '已确认金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat' },
        { prop: 'waitConfirmAmount', label: '待确认金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat' },
        { prop: 'waitRecAmount', label: '待收金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat' },
        { prop: 'refundAmount', label: '已退款金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat' },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        { prop: 'paymentStatusDesc', label: '收款状态', minWidth: '1', disabled: true },
        // 状态类型 1 待核销 2 已核销 -1 已取消 0取消中
        {
          label: '核销状态',
          prop: 'receiveStatus',
          status: 'receiveStatus',
          statusDesc: 'receiveStatusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
        {
          label: '操作',
          prop: 'operate',
          width: '100px',
          disabled: true,
          btnGroups: [
            {
              name: '添加收款',
              trackCode: 'receivablesReceiveList-4',
              showBtn: (row) => {
                // 1待收款/2部分收款 && 1待核销 && 待收金额 > 0 && 非金融单 && 有权限
                const flag = [1, 2].includes(row.paymentStatus) && row.waitRecAmount > 0 && row.receiveStatus === 1 && !row.creditOrder;
                return flag && this.$has('FWS-SFKGL-YSD-TJSK');
              },
              className: ['table-button', 'table-button-primary'],
              click: (row) => this.handleAddReceipt(row),
            },
          ],
        },
      ],
      recommendedColumn: [
        { prop: 'waitDivideAmount', label: '待分账金额(元)', minWidth: '1', slotName: 'waitDivideAmount' },
      ],
      isAddReceipt: false, // 添加收款
      currentRow: {}, // 当前信息
      sourceList: [], // 归属业务
      selectTableColumn: [],
      columnsKey: 'fwsReceiveList',
      selectList: [
        {
          title: '核销状态',
          prop: 'receiveStatus',
          dictionaryPath: '/finance/finance-receipt/FinReceiveStatusEnum',
        },
        {
          title: '应收类型',
          prop: 'type',
          dictionaryPath: '/finance/finance-receipt/FinReceiveTypeServiceDicEnum',
        },
        {
          title: '收款状态',
          prop: 'paymentStatus',
          dictionaryPath: '/finance/finance-receipt/FinReceivePaymentStatusEnum',
        },
        {
          slotName: 'sourceList',
        },
      ],
    };
  },
  computed: {
    searchParams() {
      const param = {
        ...this.queryForm,
        sourceList: this.sourceList,
      };
      param[param.searchType] = param.searchKey;
      delete param.searchType;
      delete param.searchKey;
      delete param.timeType;
      return param;
    },
    exportParams() {
      const params = { ...this.searchParams };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.resetDate();
    this.init();
  },
  methods: {
    async init() {
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.receiveListRef.doLayout();
      });
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.$refs.searchForm.resetField();
      const param = { ...queryFormDefault };
      param.searchKey = (form.list || []).join(',');
      param.searchType = form.searchType;
      this.queryForm = { ...param };
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 详情
    handleDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isDetailShow = true;
    },

    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    // 列表查询
    async getList() {
      const { searchKey, paymentStatus, receiveStatus, type } = this.queryForm;
      if (!this.queryForm.beginTime && !(searchKey || paymentStatus || receiveStatus || type || this.sourceList.length)) {
        this.resetDate();
      }
      try {
        this.loading = true;
        const res = await getReceiveList(this.searchParams);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = { ...queryFormDefault };
      this.sourceList = [];
      this.resetDate();
      this.$nextTick(() => {
        this.getList();
      });
    },
    sourceChange(list) {
      this.sourceList = [...list];
      this.refreshList();
    },
    // 添加收款
    handleAddReceipt(row) {
      this.isAddReceipt = true;
      this.currentRow = { ...row };
    },
  },
};
</script>
